import { DataSharingQuery } from 'dashboard-services';

import { useQuery } from '@tanstack/react-query';

export default (() => {

  const onSelect = ({ producers = [] }) => {
    if(producers.length > 0) {
      return producers
    } else {
      return undefined
    }
  }

  const useGetProducers = ({ getQueryBuilder, includeSelfProducer, ...rest }) => useQuery({
    ...DataSharingQuery.QUERIES.getProducers(
      getQueryBuilder,
      {
        includeSelfProducer
      }
    ),
    select: onSelect,
    ...rest
  })

  return {
    useGetProducers,
  }
})()